import React from 'react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full text-center py-2.5 px-4 text-white/25 text-[10px] sm:text-xs space-y-1 shrink-0">
      <div className="flex justify-center gap-2.5 flex-wrap">
        <a href="/privacy.html"
           className="hover:text-white/60 hover:underline transition-colors">Privacy</a>
        <span>·</span>
        <a href="/cookie-policy.html"
           className="hover:text-white/60 hover:underline transition-colors">Cookie</a>
        <span>·</span>
        <a href="/terms.html"
           className="hover:text-white/60 hover:underline transition-colors">Termini</a>
        <span>·</span>
        <a href="/about.html"
           className="hover:text-white/60 hover:underline transition-colors">Chi Siamo</a>
        <span>·</span>
        <a href="/contacts.html"
           className="hover:text-white/60 hover:underline transition-colors">Contatti</a>
        <span>·</span>
        <a href="/faq.html"
           className="hover:text-white/60 hover:underline transition-colors">FAQ</a>
      </div>
      <div>&copy; {currentYear} sbarazzino.it &mdash; Gioco gratuito supportato dalla pubblicità</div>
    </footer>
  );
}
